// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_iconSearch__HQWFc {
  align-items: center !important;
  color: #18316e !important;
  display: flex !important;
  font-size: 1.8rem !important;
}

.styles_selectContainerBanks__V\\+9xo {
  align-items: center;
  background: #ffffff;
  display: flex;
}

.styles_dropZone__gSf3F {
  align-items: center;
  background: #f8f9fc;
  border: 2px dashed #c5cee0;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  min-height: 120px;
  padding: 1.5rem;
  text-align: center;
  transition: border-color 0.2s, background 0.2s;
}

.styles_dropZone__gSf3F:hover,
.styles_dropZoneActive__pONFs {
  background: #eef2fb;
  border-color: #18316e;
}

.styles_dropZoneDisabled__rpxd\\+ {
  cursor: not-allowed;
  opacity: 0.55;
}

.styles_dropZoneDisabled__rpxd\\+:hover {
  background: #f8f9fc;
  border-color: #c5cee0;
}

.styles_dropZoneIcon__MqAnn {
  color: #18316e;
  font-size: 2rem !important;
}

.styles_fileList__-kZLp {
  color: #0f2047;
  font-size: 0.875rem;
  margin: 0.75rem 0 0;
  padding-left: 1.25rem;
}

.styles_iconeTabela__pJ4ca {
  color: #18316e !important;
}

.styles_boxAcoes__HoD8J {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.25rem;
}

.styles_celulaEllipsis__Cc8SW {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.styles_detalheLista__UEVNU {
  margin: 0.5rem 0 0;
  padding-left: 1.25rem;
}

.styles_detalheLista__UEVNU li {
  margin-bottom: 0.25rem;
}

.styles_detalheModal__YsMzY {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding-top: 0.25rem;
}

.styles_detalheStatusBar__hfbpR {
  align-items: flex-start;
  border-radius: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
}

.styles_detalheStatusSucesso__\\+DGtw {
  background: #e8f5e9;
}

.styles_detalheStatusErro__0Wp7e {
  background: #fdecea;
}

.styles_detalheStatusNeutro__EKnaI {
  background: #f5f7fb;
}

.styles_detalheStatusMensagem__AtayC {
  color: #c62828 !important;
  flex: 1 1;
  min-width: 0;
  overflow-wrap: anywhere;
  padding-top: 0.15rem;
}

.styles_detalheProgresso__Oya-j {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 140px;
}

.styles_detalheProgressoBarra__gfjrf {
  border-radius: 3px;
  height: 6px !important;
}

.styles_detalheErroBanner__Rp7q2 {
  background: #fdecea;
  border-left: 4px solid #c62828;
  border-radius: 0 8px 8px 0;
  padding: 0.75rem 1rem;
}

.styles_detalheErroTitulo__\\+k-l8 {
  color: #c62828 !important;
  margin-bottom: 0.25rem !important;
}

.styles_detalheSecao__MGUQH {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_detalheSecaoTitulo__wCeMC {
  color: #0f2047 !important;
  font-weight: 600 !important;
}

.styles_detalheAreaExemplo__y-d3L {
  background: #f8f9fc;
  border: 1px dashed #c5cee0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.85rem 1rem;
}

.styles_detalheEmpresa__I-Yam {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.styles_detalheRazaoSocial__NMVi1 {
  color: #0f2047 !important;
  font-weight: 500 !important;
  word-break: break-word;
}

.styles_detalheLinha__7BQjz {
  display: grid;
  gap: 0.75rem 1rem;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.styles_detalheGrid__XLPkQ {
  display: grid;
  gap: 0.75rem 1.25rem;
  grid-template-columns: 1fr 1fr;
}

.styles_detalheCampo__9DDHS {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.styles_detalheCampoLabel__hpfi4 {
  color: #6b7a99;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.styles_detalheCampoValor__59xnk {
  color: #0f2047;
  font-size: 0.9rem;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 600px) {
  .styles_detalheLinha__7BQjz,
  .styles_detalheGrid__XLPkQ {
    grid-template-columns: 1fr;
  }
}

.styles_logLista__C08cn {
  font-family: monospace;
  font-size: 0.8rem;
  list-style: none;
  margin: 0;
  max-height: 180px;
  overflow-y: auto;
  padding: 0.5rem 0.75rem;
  background: #f5f7fb;
  border-radius: 6px;
}

.styles_logLista__C08cn li {
  margin-bottom: 0.35rem;
}

.styles_situacaoProgresso__VtdqK {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.styles_situacaoProgressoLinha__DMY0t {
  align-items: center;
  display: flex;
  gap: 0.5rem;
}

.styles_situacaoBarra__fj73I {
  flex: 1 1;
  height: 6px !important;
  border-radius: 3px;
}

.styles_situacaoPercentual__uU7GP {
  flex-shrink: 0;
  font-weight: 600;
  min-width: 2.25rem;
  text-align: right;
}

.styles_situacaoEtapa__TnO2X {
  display: block;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.styles_saldoDivergente__H0HCV {
  color: #c62828;
  font-weight: 600;
}

.styles_saldoOk__qACYg {
  color: inherit;
}

.styles_saldoConciliadoOk__KA7MU {
  color: #2e7d32;
  font-weight: 600;
}

.styles_btnContainer__dhJcG {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0 1.5rem 1rem !important;
}

.styles_btnModal__\\+Fzoi {
  border: 1px solid #18316e !important;
  text-transform: none !important;
}

.styles_btnModal__\\+Fzoi.styles_cancelar__wSuNs {
  background: #ffffff !important;
  color: #18316e !important;
}

.styles_btnModal__\\+Fzoi.styles_prosseguir__vJtT7 {
  background: #18316e !important;
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ImportacoesExtrato/styles.module.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B","sourcesContent":[".iconSearch {\n  align-items: center !important;\n  color: #18316e !important;\n  display: flex !important;\n  font-size: 1.8rem !important;\n}\n\n.selectContainerBanks {\n  align-items: center;\n  background: #ffffff;\n  display: flex;\n}\n\n.dropZone {\n  align-items: center;\n  background: #f8f9fc;\n  border: 2px dashed #c5cee0;\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  justify-content: center;\n  min-height: 120px;\n  padding: 1.5rem;\n  text-align: center;\n  transition: border-color 0.2s, background 0.2s;\n}\n\n.dropZone:hover,\n.dropZoneActive {\n  background: #eef2fb;\n  border-color: #18316e;\n}\n\n.dropZoneDisabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.dropZoneDisabled:hover {\n  background: #f8f9fc;\n  border-color: #c5cee0;\n}\n\n.dropZoneIcon {\n  color: #18316e;\n  font-size: 2rem !important;\n}\n\n.fileList {\n  color: #0f2047;\n  font-size: 0.875rem;\n  margin: 0.75rem 0 0;\n  padding-left: 1.25rem;\n}\n\n.iconeTabela {\n  color: #18316e !important;\n}\n\n.boxAcoes {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.25rem;\n}\n\n.celulaEllipsis {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.detalheLista {\n  margin: 0.5rem 0 0;\n  padding-left: 1.25rem;\n}\n\n.detalheLista li {\n  margin-bottom: 0.25rem;\n}\n\n.detalheModal {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  padding-top: 0.25rem;\n}\n\n.detalheStatusBar {\n  align-items: flex-start;\n  border-radius: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n}\n\n.detalheStatusSucesso {\n  background: #e8f5e9;\n}\n\n.detalheStatusErro {\n  background: #fdecea;\n}\n\n.detalheStatusNeutro {\n  background: #f5f7fb;\n}\n\n.detalheStatusMensagem {\n  color: #c62828 !important;\n  flex: 1;\n  min-width: 0;\n  overflow-wrap: anywhere;\n  padding-top: 0.15rem;\n}\n\n.detalheProgresso {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  gap: 0.25rem;\n  min-width: 140px;\n}\n\n.detalheProgressoBarra {\n  border-radius: 3px;\n  height: 6px !important;\n}\n\n.detalheErroBanner {\n  background: #fdecea;\n  border-left: 4px solid #c62828;\n  border-radius: 0 8px 8px 0;\n  padding: 0.75rem 1rem;\n}\n\n.detalheErroTitulo {\n  color: #c62828 !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.detalheSecao {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.detalheSecaoTitulo {\n  color: #0f2047 !important;\n  font-weight: 600 !important;\n}\n\n.detalheAreaExemplo {\n  background: #f8f9fc;\n  border: 1px dashed #c5cee0;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.85rem 1rem;\n}\n\n.detalheEmpresa {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n}\n\n.detalheRazaoSocial {\n  color: #0f2047 !important;\n  font-weight: 500 !important;\n  word-break: break-word;\n}\n\n.detalheLinha {\n  display: grid;\n  gap: 0.75rem 1rem;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.detalheGrid {\n  display: grid;\n  gap: 0.75rem 1.25rem;\n  grid-template-columns: 1fr 1fr;\n}\n\n.detalheCampo {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.detalheCampoLabel {\n  color: #6b7a99;\n  font-size: 0.75rem;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.detalheCampoValor {\n  color: #0f2047;\n  font-size: 0.9rem;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n@media (max-width: 600px) {\n  .detalheLinha,\n  .detalheGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.logLista {\n  font-family: monospace;\n  font-size: 0.8rem;\n  list-style: none;\n  margin: 0;\n  max-height: 180px;\n  overflow-y: auto;\n  padding: 0.5rem 0.75rem;\n  background: #f5f7fb;\n  border-radius: 6px;\n}\n\n.logLista li {\n  margin-bottom: 0.35rem;\n}\n\n.situacaoProgresso {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  max-width: 100%;\n  min-width: 0;\n  width: 100%;\n}\n\n.situacaoProgressoLinha {\n  align-items: center;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.situacaoBarra {\n  flex: 1;\n  height: 6px !important;\n  border-radius: 3px;\n}\n\n.situacaoPercentual {\n  flex-shrink: 0;\n  font-weight: 600;\n  min-width: 2.25rem;\n  text-align: right;\n}\n\n.situacaoEtapa {\n  display: block;\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.saldoDivergente {\n  color: #c62828;\n  font-weight: 600;\n}\n\n.saldoOk {\n  color: inherit;\n}\n\n.saldoConciliadoOk {\n  color: #2e7d32;\n  font-weight: 600;\n}\n\n.btnContainer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n  padding: 0 1.5rem 1rem !important;\n}\n\n.btnModal {\n  border: 1px solid #18316e !important;\n  text-transform: none !important;\n}\n\n.btnModal.cancelar {\n  background: #ffffff !important;\n  color: #18316e !important;\n}\n\n.btnModal.prosseguir {\n  background: #18316e !important;\n  color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconSearch": `styles_iconSearch__HQWFc`,
	"selectContainerBanks": `styles_selectContainerBanks__V+9xo`,
	"dropZone": `styles_dropZone__gSf3F`,
	"dropZoneActive": `styles_dropZoneActive__pONFs`,
	"dropZoneDisabled": `styles_dropZoneDisabled__rpxd+`,
	"dropZoneIcon": `styles_dropZoneIcon__MqAnn`,
	"fileList": `styles_fileList__-kZLp`,
	"iconeTabela": `styles_iconeTabela__pJ4ca`,
	"boxAcoes": `styles_boxAcoes__HoD8J`,
	"celulaEllipsis": `styles_celulaEllipsis__Cc8SW`,
	"detalheLista": `styles_detalheLista__UEVNU`,
	"detalheModal": `styles_detalheModal__YsMzY`,
	"detalheStatusBar": `styles_detalheStatusBar__hfbpR`,
	"detalheStatusSucesso": `styles_detalheStatusSucesso__+DGtw`,
	"detalheStatusErro": `styles_detalheStatusErro__0Wp7e`,
	"detalheStatusNeutro": `styles_detalheStatusNeutro__EKnaI`,
	"detalheStatusMensagem": `styles_detalheStatusMensagem__AtayC`,
	"detalheProgresso": `styles_detalheProgresso__Oya-j`,
	"detalheProgressoBarra": `styles_detalheProgressoBarra__gfjrf`,
	"detalheErroBanner": `styles_detalheErroBanner__Rp7q2`,
	"detalheErroTitulo": `styles_detalheErroTitulo__+k-l8`,
	"detalheSecao": `styles_detalheSecao__MGUQH`,
	"detalheSecaoTitulo": `styles_detalheSecaoTitulo__wCeMC`,
	"detalheAreaExemplo": `styles_detalheAreaExemplo__y-d3L`,
	"detalheEmpresa": `styles_detalheEmpresa__I-Yam`,
	"detalheRazaoSocial": `styles_detalheRazaoSocial__NMVi1`,
	"detalheLinha": `styles_detalheLinha__7BQjz`,
	"detalheGrid": `styles_detalheGrid__XLPkQ`,
	"detalheCampo": `styles_detalheCampo__9DDHS`,
	"detalheCampoLabel": `styles_detalheCampoLabel__hpfi4`,
	"detalheCampoValor": `styles_detalheCampoValor__59xnk`,
	"logLista": `styles_logLista__C08cn`,
	"situacaoProgresso": `styles_situacaoProgresso__VtdqK`,
	"situacaoProgressoLinha": `styles_situacaoProgressoLinha__DMY0t`,
	"situacaoBarra": `styles_situacaoBarra__fj73I`,
	"situacaoPercentual": `styles_situacaoPercentual__uU7GP`,
	"situacaoEtapa": `styles_situacaoEtapa__TnO2X`,
	"saldoDivergente": `styles_saldoDivergente__H0HCV`,
	"saldoOk": `styles_saldoOk__qACYg`,
	"saldoConciliadoOk": `styles_saldoConciliadoOk__KA7MU`,
	"btnContainer": `styles_btnContainer__dhJcG`,
	"btnModal": `styles_btnModal__+Fzoi`,
	"cancelar": `styles_cancelar__wSuNs`,
	"prosseguir": `styles_prosseguir__vJtT7`
};
export default ___CSS_LOADER_EXPORT___;
